<!--
 * @Descripttion: 查看明细(项目服务费订单)
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="order-detail-c">
    <xrk-table
      style="height: 650px"
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
    <div
      v-if="+detailInfo.isEdit === 1"
      style="margin: 0 auto; width: 80px; height: 80px; padding-bottom: 20px"
    >
      <BaseButton style="width: 80px" @click="onRemove">移除</BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  useTableColumn,
  BaseButton,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';

import { viewDetails, removePerson } from '../data-source/apis';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';
import {
  indexCol,
  fullNameCol,
  phoneCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  payStatusCol,
  endPointFinishPayAtCol,
  orderNoCol
} from '../fields/columns';
import {
  fullNameSearch,
  phoneSearch,
  payStatusSearch
} from '../fields/searchs';
import {
  batchDownLoadReceiptBySupplier,
  downLoadReceipt
} from '@/common/hooks/order/order-download';
const route = useRoute();

const detailInfo = computed(() => {
  return {
    id: +route.query.id,
    isEdit: +route.query.isEdit || 0 //是否是修改 1是 0否
  };
});

const xrkTableRef = ref<XrkTableRef>();

// 搜索项
const searchConfig = computed<XrkTableProps['searchConfig']>(() => {
  return {
    searchBtn: {
      show: true,
      text: '搜索'
    },
    resetBtn: {
      show: true,
      text: '重置'
    },
    searchColumns: [
      fullNameSearch,
      phoneSearch,
      !detailInfo.value.isEdit && {
        ...payStatusSearch,
        config: {
          options: ORDER_PAY_STATUS_PAY_SUCCESS
        }
      }
    ].filter(Boolean),
    otherComponents: [
      !detailInfo.value.isEdit && {
        render() {
          return (
            <>
              <BaseButton
                type="primary2"
                onClick={async () => {
                  //批量下载回单
                  await batchDownLoadReceiptBySupplier({
                    downloadType: 702,
                    downloadList: [
                      {
                        id: detailInfo.value.id,
                        supplierOrderId: detailInfo.value.id
                      }
                    ]
                  });
                }}
              >
                批量下载回单
              </BaseButton>
            </>
          );
        }
      }
    ].filter(Boolean)
  };
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      detailInfo.value.isEdit === 1 &&
        useTableColumn({
          type: '_selection',
          prop: 'id',
          align: 'center',
          fixed: 'left',
          width: 120,
          selectionDisabled(row) {
            return [1, 2].includes(+row.payStatus);
          }
        }),
      indexCol,
      fullNameCol,
      phoneCol,
      orderNoCol,
      settlementTaskCountCol,
      taskPriceCol,
      projectPayPriceCol,
      {
        ...payStatusCol,
        formatter({ cellValue }) {
          return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
        }
      },
      !detailInfo.value.isEdit && endPointFinishPayAtCol,
      !detailInfo.value.isEdit &&
        useTableColumn({
          align: 'center',
          fixed: 'right',
          label: '操作',
          render({ row }) {
            return (
              <>
                <div>
                  <BaseButton
                    disabled={!row.receiptUrl || row.receiptUrl === '-'}
                    onClick={async () => {
                      // 下载回单
                      downLoadReceipt(row.receiptUrl);
                    }}
                    type="text"
                  >
                    下载回单
                  </BaseButton>
                </div>
              </>
            );
          }
        })
    ].filter(Boolean)
  };
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    id: detailInfo.value.id
  };
  const data = await viewDetails(reqData);
  return data;
};

const onRefreshTabel = () => {
  xrkTableRef.value.initCurrentList();
};
const selectionVal = computed(() => {
  return xrkTableRef.value?.getSelectionRows();
});
const onRemove = async () => {
  if (!selectionVal.value.length) {
    XrkMessage.warning('请选择要操作的数据');
    return;
  }
  await XrkMessageBox.confirm(
    '移除后，将不能重新加入到当前订单内，订单关联综合服务费订单金额将会重新计算，请谨慎操作。',
    '确认',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消'
    }
  );
  await removePerson({
    idList: selectionVal.value.map(item => item.id)
  });
  xrkTableRef.value.clearSelectionRows();
  onRefreshTabel();
};
</script>
<style lang="scss"></style>
